
const AmazonLinkRenderer = (props) => {
    const url = `https://www.amazon.de/dp/${encodeURIComponent(props.value)}`;
    return (
      <button className="amazon-link-button"
        onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
      >
        Amazon ↗
      </button>
    );
  };
  
  export default AmazonLinkRenderer